import { IBaseModel, IOptionType } from '@zz2/zz2-ui';
import lodash from 'lodash';
import { IDevice } from './masterData/device/device';
import { IEmployee } from './rights/employee/employee';
import { IUser } from './auth/user/user';
import { ICountry } from './masterData/country/country';
import { ArrayHelper } from '@zz2/zz2-ts-utilities';

interface ILabelSection {
    order : number;
    section : string;
}

export default class OptionType {
    public static fromDataModel = function<T extends IBaseModel>(dataModel : T) : IOptionType {
        let labelSections : Array<ILabelSection> = [];

        if ('code' in dataModel && typeof dataModel.code === 'string' && dataModel.code !== '') {
            const labelSection : ILabelSection = {
                order: 1,
                section: dataModel.code.trim(),
            };

            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('name' in dataModel && typeof dataModel.name === 'string' && dataModel.name !== '') {
            const labelSection : ILabelSection = {
                order: 2,
                section: dataModel.name.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('description' in dataModel
            && typeof dataModel.description === 'string'
            && dataModel.description !== ''
            && labelSections.length < 2) { // We don't want to add a description if the code and name have already been added.
            const labelSection : ILabelSection = {
                order: 3,
                section: dataModel.description.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if (labelSections.length < 1) {
            return {
                label: 'Label Not Found',
                value: dataModel.id,
            };
        }

        if (labelSections.length > 1) {
            const orderedList = lodash.orderBy(labelSections, x => x.order, 'asc');
            return {
                label: `(${orderedList[0].section}) - ${orderedList[1].section}`,
                value: dataModel.id,
            };
        } else {
            return {
                label: labelSections[0].section,
                value: dataModel.id,
            };
        }
    }

    public static fromCountry = (country : ICountry) : IOptionType => {
        return {
            label: `(${country.alpha3Code}) - ${country.name}`,
            value: country.id,
        };
    }

    public static fromDevice = (device : IDevice) : IOptionType => {
        return {
            label: device.primaryImei,
            value: device.id,
        };
    }

    public static fromEmployee = (employee : IEmployee) : IOptionType => {
        return {
            label: `(${employee.number}) -  ${employee.fullName}`,
            value: employee.id,
        };
    }

    public static fromUser = (user : IUser) : IOptionType => {
        return {
            label: user.name,
            value: user.id,
        };
    }
}